/**
 * Profession codes and locale-aware display mapping.
 * Mirrors the API's profession.ts — display concerns only.
 */

export const PROFESSION_OPTIONS = [
  { code: 'DOCTOR_M',   label: 'Médico' },
  { code: 'DOCTOR_F',   label: 'Médica' },
  { code: 'ATTORNEY_M', label: 'Advogado' },
  { code: 'ATTORNEY_F', label: 'Advogada' },
  { code: 'SECRETARY',  label: 'Secretário(a)' },
  { code: 'ADMIN',      label: 'Administrador(a)' },
  { code: 'TECHNICIAN', label: 'Técnico(a)' },
];

const PROFESSION_MAP = {
  DOCTOR_M:   { 'pt-BR': { label: 'Médico',          prefix: 'Dr.'  }, 'en-US': { label: 'Doctor',         prefix: 'Dr.'  } },
  DOCTOR_F:   { 'pt-BR': { label: 'Médica',          prefix: 'Dra.' }, 'en-US': { label: 'Doctor',         prefix: 'Dr.'  } },
  ATTORNEY_M: { 'pt-BR': { label: 'Advogado',        prefix: 'Dr.'  }, 'en-US': { label: 'Attorney',       prefix: ''     } },
  ATTORNEY_F: { 'pt-BR': { label: 'Advogada',        prefix: 'Dra.' }, 'en-US': { label: 'Attorney',       prefix: ''     } },
  SECRETARY:  { 'pt-BR': { label: 'Secretário(a)',    prefix: ''     }, 'en-US': { label: 'Secretary',      prefix: ''     } },
  ADMIN:      { 'pt-BR': { label: 'Administrador(a)', prefix: ''     }, 'en-US': { label: 'Administrator',  prefix: ''     } },
  TECHNICIAN: { 'pt-BR': { label: 'Técnico(a)',       prefix: ''     }, 'en-US': { label: 'Technician',     prefix: ''     } },
};

const DEFAULT_LOCALE = 'pt-BR';

export function getProfessionLabel(code, locale = DEFAULT_LOCALE) {
  if (!code) return '';
  return PROFESSION_MAP[code]?.[locale]?.label ?? code;
}

export function getProfessionPrefix(code, locale = DEFAULT_LOCALE) {
  if (!code) return '';
  return PROFESSION_MAP[code]?.[locale]?.prefix ?? '';
}

export function getDisplayName(name, profession, locale = DEFAULT_LOCALE) {
  const prefix = getProfessionPrefix(profession, locale);
  return prefix ? `${prefix} ${name}` : name;
}
